<script setup lang="ts">
import { DependencyInjectionSymbols } from '~/core/helpers/symbols';
import { cn } from '~/utils';

/**
 * Layout só da rota /shorts: header fixo com animação ao rolar (compacto).
 * Mobile: header z-[35] para a FiltersBar (z-40) ficar clicável sobre o logo.
 * Menu mobile usa Teleport para `body` (via inject em PortalHeaderNavMobileGeneric).
 */
provide(DependencyInjectionSymbols.shortsMobileNavTeleportToBody, true);

const isCompact = useState('shorts-scroll-compact', () => false);
const isHeaderHidden = computed(() => isCompact.value);
</script>
<template>
	<div
		:class="
			cn(
				'min-h-screen bg-primary transition-[padding-top] duration-200 ease-out lg:duration-300 lg:ease-[cubic-bezier(0.25,0.1,0.25,1)] max-lg:bg-black',
				isHeaderHidden ? 'pt-2 md:pt-2' : 'pt-[60px] lg:pt-20'
			)
		"
	>
		<!--
			Mobile: o header faz translate-y ao compactar; o fundo do <nav> se move junto e o scroll
			deixa ver o feed na faixa de 60px. Esta camada não anima, fica fixa sob o header (z menor).
		-->
		<div
			v-show="!isHeaderHidden"
			class="pointer-events-none fixed inset-x-0 top-0 z-[34] hidden h-[60px] bg-primary max-lg:block lg:hidden"
			aria-hidden="true"
		/>

		<PortalHeader
			variant="primary"
			fixed
			:class="[
				'h-[60px] lg:h-20 transform will-change-transform transition-transform duration-200 ease-out lg:duration-300 lg:ease-[cubic-bezier(0.25,0.1,0.25,1)]',
				'fixed left-0 top-0 w-full max-lg:z-[35] lg:z-[100]',
				isHeaderHidden
					? '-translate-y-full pointer-events-none'
					: 'translate-y-0'
			]"
		/>

		<main class="box-border size-full bg-black">
			<slot />
		</main>
	</div>
</template>
